import React, { useState } from 'react'

export default function AddMemberModal({clubs, onClose, onSave}){
  const [name, setName] = useState('')
  const [clubId, setClubId] = useState('')
  const [saving, setSaving] = useState(false)

  async function handleSave(){
    if(!name.trim()) return
    setSaving(true)
    try{
      await onSave({ name: name.trim(), club_id: clubId || null })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#fff',padding:20,borderRadius:8,width:'90%',maxWidth:420}}>
        <h3>Add Member</h3>
        <div style={{display:'grid',gap:10,marginTop:10}}>
          <label>Name
            <input value={name} onChange={e=>setName(e.target.value)} autoFocus style={{width:'100%'}} />
          </label>
          <label>Club (optional)
            <select value={clubId} onChange={e=>setClubId(e.target.value)} style={{width:'100%'}}>
              <option value="">-- no club --</option>
              {clubs.map(c=> <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
        </div>
        <div style={{textAlign:'right', marginTop:16}}>
          <button className="secondary" onClick={onClose} style={{marginRight:8}} disabled={saving}>Cancel</button>
          <button className="primary" onClick={handleSave} disabled={saving || !name.trim()}>{saving ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  )
}
